import { jsxs as _jsxs } from "react/jsx-runtime";
import translations from './lang';
import { ErrorText } from './subcomponents';
var i18n = function (currentLanguage) {
    /**
     * This finds a string from <language>.ts, then replaces its slots with values, returning a fully formatted string for the UI.
     * example: useTranslation('myKey.myStringValue', {value: 'foo'})
     * @param {string} translation string from <language>.ts
     * @param {[key: string]: string} values Dynamic object values for string {{placeholder}} to replace slot.
     */
    return function (translation, values) {
        var strings = translations[currentLanguage];
        var keys = translation.split('.');
        var messageKey = keys[0];
        var message = keys[1];
        var result;
        if (typeof message === 'string' &&
            Object.keys(strings).includes(messageKey)) {
            result = strings[messageKey][message];
        }
        else {
            result = _jsxs(ErrorText, { children: ["Invalid translation key: ", messageKey] });
        }
        if (typeof result !== 'string') {
            result = _jsxs(ErrorText, { children: ["Missing translation for: ", translation] });
        }
        if (values) {
            var pattern = /\{\{(\w+)\}\}/;
            if (pattern.test(result)) {
                result = result.replace(pattern, function (_, placeholder) {
                    return values[placeholder];
                });
            }
            else {
                result = (_jsxs(ErrorText, { children: ["Missing ", Object.keys(values), " placeholder for: ", translation] }));
            }
        }
        return result;
    };
};
export default i18n;
//# sourceMappingURL=i18n.js.map